import { c as _c } from "react/compiler-runtime";
import { Box, Card, colors, formatters, Flexbox, MiniIconEmail, MiniIconLocation, MiniIconPhone, Padding, Spacing, Stack, Text, TextLink, Tooltip, Menu2 as Menu, PopoverMenu } from '@newfront-insurance/core-ui';
import type { MenuItem2 as MenuItem } from '@newfront-insurance/core-ui';
import { useNotify } from '@newfront-insurance/next-notifications';
import type { JSX } from 'react';
import type { Contact } from '../../bff/types';
interface Props {
  contact: Contact;
  isKeyContact?: boolean;
  type?: 'fluid' | 'fixed';
  maxWidth?: string;
  menuItems?: MenuItem[];
}
export function ContactCard(t0) {
  const $ = _c(57);
  const {
    contact,
    isKeyContact: t1,
    type: t2,
    maxWidth: t3,
    menuItems: t4
  } = t0;
  const isKeyContact = t1 === undefined ? false : t1;
  const type = t2 === undefined ? "fixed" : t2;
  const maxWidth = t3 === undefined ? "290px" : t3;
  let t5;
  if ($[0] !== t4) {
    t5 = t4 === undefined ? [] : t4;
    $[0] = t4;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const menuItems = t5;
  const cardColor = isKeyContact ? "#042553" : "#ffffff";
  const borderColor = isKeyContact ? "#042553" : colors.steel[200];
  const textColor = isKeyContact ? "#ffffff" : colors.steel[500];
  const subtextColor = colors.steel[isKeyContact ? 200 : 400];
  let t6;
  if ($[2] !== contact.firstName || $[3] !== contact.lastName || $[4] !== contact.middleName) {
    t6 = [contact.firstName, contact.middleName, contact.lastName];
    $[2] = contact.firstName;
    $[3] = contact.lastName;
    $[4] = contact.middleName;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const contactName = t6.join(" ");
  const notify = useNotify();
  let t7;
  if ($[6] !== notify) {
    t7 = async function copyEmail(email) {
      if (email) {
        await navigator.clipboard.writeText(email);
        notify.success("Email copied successfully");
      }
    };
    $[6] = notify;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const copyEmail = t7;
  const t8 = type === "fluid" ? "100%" : maxWidth;
  let t9;
  if ($[8] !== t8) {
    t9 = {
      maxWidth: t8
    };
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      position: "relative"
    };
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== menuItems) {
    t11 = menuItems.length > 0 && <Box style={{
      position: "absolute",
      top: "16px",
      right: "14px"
    }}><PopoverMenu options={{
        targetAnchor: "bottomRight",
        anchor: "topRight"
      }} type="more">{toggleMenu => <Menu onItemClick={toggleMenu} items={menuItems} />}</PopoverMenu></Box>;
    $[11] = menuItems;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== isKeyContact || $[14] !== textColor) {
    t12 = isKeyContact && <Padding bottom={8}><Text size="small" weight={600} color={textColor} style={{
        letterSpacing: `0.1em`,
        textTransform: `uppercase`
      }}>Key Contact</Text></Padding>;
    $[13] = isKeyContact;
    $[14] = textColor;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== contactName || $[17] !== textColor) {
    t13 = contactName && <Text weight={600} color={textColor}>{`${contactName}`}</Text>;
    $[16] = contactName;
    $[17] = textColor;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== contact.title || $[20] !== subtextColor) {
    t14 = contact.title && <Text size="small" weight={600} color={subtextColor}>{contact.title}</Text>;
    $[19] = contact.title;
    $[20] = subtextColor;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== contact.email || $[23] !== contact.mailingAddress || $[24] !== contact.phone) {
    t15 = contact.email || contact.phone || contact.mailingAddress ? <Spacing height={8} /> : null;
    $[22] = contact.email;
    $[23] = contact.mailingAddress;
    $[24] = contact.phone;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== contact.email || $[27] !== copyEmail || $[28] !== isKeyContact || $[29] !== textColor) {
    t16 = contact.email && <Stack direction="horizontal" gap={8} alignItems="center"><TextLink onClick={() => copyEmail(contact.email)}><Tooltip text="Copy email" positionTip="right"><MiniIconEmail color={isKeyContact ? "#ffffff" : colors.steel[400]} /></Tooltip></TextLink><TextLink href={`mailto:${contact.email}`} target="_blank" underline={false} underlineOnHover={true} style={{
        color: textColor
      }}>{contact.email}</TextLink></Stack>;
    $[26] = contact.email;
    $[27] = copyEmail;
    $[28] = isKeyContact;
    $[29] = textColor;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== contact.phone || $[32] !== isKeyContact || $[33] !== textColor) {
    t17 = contact.phone && <Stack direction="horizontal" gap={8} alignItems="center"><MiniIconPhone color={isKeyContact ? "#ffffff" : colors.steel[400]} /><TextLink href={`tel:${contact.phone}`} target="_blank" underline={false} underlineOnHover={true} style={{
        color: isKeyContact ? "#ffffff" : textColor
      }}>{formatters.phoneNumber(contact.phone)}</TextLink></Stack>;
    $[31] = contact.phone;
    $[32] = isKeyContact;
    $[33] = textColor;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== contact.mailingAddress || $[36] !== isKeyContact || $[37] !== textColor) {
    t18 = contact.mailingAddress && <Flexbox alignItems="flex-start" flexDirection="row" justifyContent="flex-start"><Padding top={4}><MiniIconLocation color={isKeyContact ? "#ffffff" : colors.steel[400]} /></Padding><Flexbox flexDirection="column"><Padding left={8}><Text color={textColor}>{`${contact.mailingAddress.addressLine1}, ${contact.mailingAddress.city}`}</Text><Text color={textColor}>{`${contact.mailingAddress.stateOrArea}, ${contact.mailingAddress.postalCode}`}</Text></Padding></Flexbox></Flexbox>;
    $[35] = contact.mailingAddress;
    $[36] = isKeyContact;
    $[37] = textColor;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== t16 || $[40] !== t17 || $[41] !== t18) {
    t19 = <Stack direction="vertical" gap={4}>{t16}{t17}{t18}</Stack>;
    $[39] = t16;
    $[40] = t17;
    $[41] = t18;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== t12 || $[44] !== t13 || $[45] !== t14 || $[46] !== t15 || $[47] !== t19) {
    t20 = <Padding size={16}>{t12}{t13}{t14}{t15}{t19}</Padding>;
    $[43] = t12;
    $[44] = t13;
    $[45] = t14;
    $[46] = t15;
    $[47] = t19;
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  let t21;
  if ($[49] !== borderColor || $[50] !== cardColor || $[51] !== t11 || $[52] !== t20) {
    t21 = <Card style={t10} backgroundColor={cardColor} borderColor={borderColor} hasShadow={false}>{t11}{t20}</Card>;
    $[49] = borderColor;
    $[50] = cardColor;
    $[51] = t11;
    $[52] = t20;
    $[53] = t21;
  } else {
    t21 = $[53];
  }
  let t22;
  if ($[54] !== t21 || $[55] !== t9) {
    t22 = <Box style={t9}>{t21}</Box>;
    $[54] = t21;
    $[55] = t9;
    $[56] = t22;
  } else {
    t22 = $[56];
  }
  return t22;
}